export default __webpack_public_path__ + "static/media/Plantillas.b7af4990.svg";